import "./assets/index.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import { Route, Routes } from "react-router-dom";

import AuthContext from "./context/auth_context";
import Blog from "./pages/Blog/Blog";
import BlogDetail from "./pages/Blog/BlogDetail";
import Cart from "./pages/Cart/Cart";
import Catalog from "./pages/Catalog/Catalog";
import ChangePassword from "./pages/ChangePassword";
import Chat from "./pages/Chat/Chat";
import Checkout from "./pages/Cart/Checkout";
import Education from "./pages/Education/Education";
import EducationList from "./pages/Education/EducationList";
import EducationRoute from "./utils/EducationRoute";
import ErrorPage from "./pages/ErrorPage";
import Faq from "./pages/Faq";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotPasswordCode from "./pages/Auth/ForgotPasswordCode";
import Home from "./pages/Home";
import Information from "./pages/Information/Information";
import Intro from "./pages/Intro";
import Language from "./pages/Language";
import Leaderboard from "./pages/Leaderboard";
import Lessons from "./pages/Education/Lessons";
import LessonsArchive from "./pages/Education/LessonsArchive";
import Login from "./pages/Auth/Login";
import MyProfile from "./pages/Profile/MyProfile";
import Notification from "./pages/Notification/Notification";
import Order from "./pages/Order/Order";
import OrderDetail from "./pages/Order/OrderDetail";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import ProfileChange from "./pages/Profile/ProfileChange";
import Promotion from "./pages/Promotion/Promotion";
import PromotionDetail from "./pages/Promotion/PromotionDetail";
import Questions from "./pages/Education/Questions";
import Registration from "./pages/Auth/Registration";
import RegistrationCode from "./pages/Auth/RegistrationCode";
import Reward from "./pages/Reward/Reward";
import RewardDetail from "./pages/Reward/RewardDetail";
import RewardPage from "./pages/RewardPage";
import SecurityRoute from "./utils/security/SecurityRoute";
import SetNewPassword from "./pages/SetNewPassword";
import Settings from "./pages/SettingsUser/Settings";
import TaskDetail from "./pages/Task/TaskDetail";
import TaskList from "./pages/Task/TaskList";
import Terms from "./pages/Terms";
import TermsConditions from "./pages/TermsConditions";
import { ToastContainer } from "react-toastify";
import TranslationProvider from "./utils/TranslationProvider";
import UserPoints from "./pages/UserPoints/UserPoints";
import UserReward from "./pages/UserReward";
import VideoEducation from "./pages/Education/VideoEducation";
import VideoEducationArchive from "./pages/Education/VideoEducationArchive";
import { securityActions } from "./reducers/security";
import store from "./reducers";
import { useSelector } from "react-redux";

//pages
const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));

if (loggedUser) {
  store.dispatch(securityActions.setCurrentUser(loggedUser));
}

function App() {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const isAuthenticated = loggedUserReducer?.validUser;
  return (
    <TranslationProvider>
      <AuthContext.Provider
        value={{
          ...loggedUserReducer,
        }}
      >
        <Routes>
          {isAuthenticated ? (
            <Route
              exact
              path={"/"}
              element={<SecurityRoute component={Home} />}
            />
          ) : (
            // Ruta za neprijavljene korisnike
            <Route path="/" element={<Intro />} />
          )}
          <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/registration-code" element={<RegistrationCode />} />
          <Route
            path="/forgot-password-code"
            element={<ForgotPasswordCode />}
          />

          <Route
            exact
            path={"/education-list"}
            element={<SecurityRoute component={EducationList} />}
          />
          <Route
            exact
            path={"/education/:id"}
            element={<SecurityRoute component={Education} />}
          />
          <Route
            exact
            path={"/lessons"}
            element={<EducationRoute component={Lessons} />}
          />
          <Route
            exact
            path={"/lessons-archive"}
            element={<SecurityRoute component={LessonsArchive} />}
          />

          <Route
            exact
            path={"/questions"}
            element={<EducationRoute component={Questions} />}
          />

          <Route
            exact
            path={"/video-education"}
            element={<EducationRoute component={VideoEducation} />}
          />

          <Route
            exact
            path={"/video-education-archive"}
            element={<SecurityRoute component={VideoEducationArchive} />}
          />

          <Route
            exact
            path={"/blog"}
            element={<SecurityRoute component={Blog} />}
          />
          <Route
            exact
            path={"/blog-detail/:id"}
            element={<SecurityRoute component={BlogDetail} />}
          />

          <Route
            exact
            path={"/catalog/:id"}
            element={<SecurityRoute component={Catalog} />}
          />

          <Route
            exact
            path={"/chat"}
            element={<SecurityRoute component={Chat} />}
          />

          <Route
            exact
            path={"/order"}
            element={<SecurityRoute component={Order} />}
          />
          <Route
            exact
            path={"/order-detail/:id"}
            element={<SecurityRoute component={OrderDetail} />}
          />

          <Route
            exact
            path={"/promotion"}
            element={<SecurityRoute component={Promotion} />}
          />
          <Route
            exact
            path={"/promotion-detail/:id"}
            element={<SecurityRoute component={PromotionDetail} />}
          />

          <Route
            exact
            path={"/profile"}
            element={<SecurityRoute component={MyProfile} />}
          />

          <Route
            exact
            path={"/reward"}
            element={<SecurityRoute component={Reward} />}
          />
          <Route
            exact
            path={"/reward-detail/:id"}
            element={<SecurityRoute component={RewardDetail} />}
          />

          <Route
            exact
            path={"/cart"}
            element={<SecurityRoute component={Cart} />}
          />
          <Route
            exact
            path={"/checkout"}
            element={<SecurityRoute component={Checkout} />}
          />
          <Route
            exact
            path={"/notification"}
            element={<SecurityRoute component={Notification} />}
          />
          <Route
            exact
            path={"/settings"}
            element={<SecurityRoute component={Settings} />}
          />
          <Route
            exact
            path={"/user-points"}
            element={<SecurityRoute component={UserPoints} />}
          />
          <Route
            exact
            path={"/task"}
            element={<SecurityRoute component={TaskList} />}
          />
          <Route
            exact
            path={"/task-detail/:id"}
            element={<SecurityRoute component={TaskDetail} />}
          />
          <Route
            exact
            path={"/informations"}
            element={<SecurityRoute component={Information} />}
          />
          <Route
            exact
            path={"/privacy-policy"}
            element={<SecurityRoute component={Terms} />}
          />
          <Route
            exact
            path={"/terms-conditions"}
            element={<SecurityRoute component={TermsConditions} />}
          />
          <Route
            exact
            path={"/profile-change"}
            element={<SecurityRoute component={ProfileChange} />}
          />
          <Route
            exact
            path={"/faq"}
            element={<SecurityRoute component={Faq} />}
          />
          <Route
            exact
            path={"/user-reward"}
            element={<SecurityRoute component={UserReward} />}
          />
          <Route
            exact
            path={"/language"}
            element={<SecurityRoute component={Language} />}
          />
          <Route
            exact
            path={"/reward-list"}
            element={<SecurityRoute component={RewardPage} />}
          />
          {/* <Route
            exact
            path={"/leaderboard"}
            element={<SecurityRoute component={Leaderboard} />}
          /> */}
          <Route
            exact
            path={"/change-password"}
            element={<SecurityRoute component={ChangePassword} />}
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset/:id" element={<SetNewPassword />} />
          <Route
            exact
            path={"*"}
            element={<SecurityRoute component={ErrorPage} />}
          />
        </Routes>
        <ToastContainer />
        <PWAInstallPrompt />
      </AuthContext.Provider>
    </TranslationProvider>
  );
}

export default App;
